import { render, staticRenderFns } from "./Mindset.vue?vue&type=template&id=29a59b39&scoped=true&"
import script from "./Mindset.vue?vue&type=script&lang=js&"
export * from "./Mindset.vue?vue&type=script&lang=js&"
import style0 from "./Mindset.vue?vue&type=style&index=0&id=29a59b39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a59b39",
  null
  
)

export default component.exports